import {Component, OnInit, ViewChild} from '@angular/core';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';
import {LocalStorageService} from 'ng2-webstorage';
import {MessageService} from 'primeng/components/common/messageservice';

@Component({
  selector: 'app-student-profile',
  templateUrl: './add-teacher.component.html',
  styleUrls: ['./add-teacher.component.css']
})

export class AddTeacherComponent implements OnInit {
  public SubjectsSemesterInfoData : any =[] ;
  public TeacherDetailsData : any = [];
  public TeacherId : any;
  public TeacherStdSectionData : any = [];
  public TeacherSectionData : any = [];
  public TeacherSubjectData : any = [];
  public SubTeacherId : any;
  public StandardId : any;
  public SectionId : any;
  public SubjectId : any;
  public ListOfSem : any = [];
  public SemArray : any = [];

  public selectedTitle : any;
  public enteredFirstName : string;
  public enteredLastName : string;
  public enteredMiddleName : string;
  public enteredEmail : string;
  public enteredPhone : string;

  constructor(private dataAnalyticsService: DataAnalyticsService, private localStorage: LocalStorageService, private messageService: MessageService) {
  }
  ngOnInit() {
    this.GetTeacherDetails();

  }

  onRegisterClick(){
    // Determine gender based on salutation
    let genderId = 0; // Default to 0 (unspecified)
    switch (this.selectedTitle) {
      case 'Mr.':
        genderId = 1; // Assuming 1 represents male
        break;
      case 'Ms.':
      case 'Mrs.':
      case 'Miss':
        genderId = 2; // Assuming 2 represents female
        break;
      default:
        break;
    }

    // Get current date and format it to "YYYY-MM-DDTHH:MM:SSZ"
    let currentDate = new Date();
    let createdDate = currentDate.toISOString();

    // Get date 10 years from now and format it to "YYYY-MM-DDTHH:MM:SSZ"
    let endDate = new Date();
    endDate.setFullYear(endDate.getFullYear() + 10);

    // Create payload object
    let payload = {
      "Salutation": this.selectedTitle,
      "Firstname": this.enteredFirstName,
      "Lastname": this.enteredLastName,
      "Middlename": this.enteredMiddleName,
      "Email": this.enteredEmail,
      "Phonenumber": this.enteredPhone,
      "Genderid": genderId,
      "Username": "",  // Assuming no value needed. Update accordingly.
      "Password": "",  // Assuming no value needed. Update accordingly.
      "Code": "",      // Assuming no value needed. Update accordingly.
      "Enddate": endDate.toISOString(),
      "Createddate": createdDate,
      "Modifieddate": createdDate, // Here we assume that the Modifieddate is the same as Createddate
    };

    this.dataAnalyticsService.postSchoolTeacherDetails(payload).subscribe(
      response => {
        console.log(response);
        let res: any = response;
        if (typeof res.Value === 'string') {
          // Success message
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: res.Value,
          });

          this.selectedTitle = '';
          this.enteredFirstName = '';
          this.enteredLastName = '';
          this.enteredMiddleName = '';
          this.enteredEmail = '';
          this.enteredPhone = '';
        } else if (res.Value && res.Value.Data) {
          // Server-side error message
          this.messageService.add({
            severity: "error",
            summary: "Talkative Parents",
            detail: "Please enter all the fields",
          });
        }
      },
      error => {
        console.log(error);
        this.messageService.add({
          severity: "error",
          summary: "Talkative Parents",
          detail: "Failed to add Teacher",
        });
      }
    );
  }



  private GetTeacherDetails(){
    this.dataAnalyticsService.getTeacherDetails()._finally(()=> { }).subscribe(
      response => {
        this.TeacherDetailsData = response['teacherdetailList'];
        console.log(this.TeacherDetailsData);
      }
    )
  }

}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/teacher-details/add-teacher/add-teacher.component.ts